import { render, staticRenderFns } from "./suggestionsListViewerButtons.vue.html?vue&type=template&id=332f061a&"
import script from "./suggestionsListViewerButtons.ts?vue&type=script&lang=ts&"
export * from "./suggestionsListViewerButtons.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports